import { styled } from "@mui/material";
import { Box } from "@mui/system";

export const Layout = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Icon = styled("div")`
  margin-right: 8px;
  display: flex;
  align-items: center;
`;
